<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.mobile_feature.about_us.about_us') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('administration.mobile_feature.about_us.about_us'),
            href: '/abouts'
          },
          {
            text: $t('administration.mobile_feature.about_us.edit'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-tabs target="gTab">
          <ts-tab>{{
            $t('administration.mobile_feature.about_us.kh_content')
          }}</ts-tab>
          <ts-tab>
            <span :class="{ 'text-danger': errors.has('content_en') }">
              {{ $t('administration.mobile_feature.about_us.en_content') }}
              <span class="text-danger">*</span>
            </span>
          </ts-tab>
        </ts-tabs>
        <ts-tab-panes name="gTab">
          <ts-tab-pane>
            <VueEditor
              ref="content_kh"
              v-model="model.content_kh"
              :editor-toolbar="customToolbar"
              useCustomImageHandler
              @imageAdded="handleImageAdded"
            />
          </ts-tab-pane>
          <ts-tab-pane>
            <VueEditor
              v-model="model.content_en"
              :editor-toolbar="customToolbar"
              useCustomImageHandler
              @imageAdded="handleImageAdded"
            />
          </ts-tab-pane>
        </ts-tab-panes>
        <div class="row">
          <div class="col-sm-4 text-left mt-2">
            <span
              v-if="errors.has('content_en')"
              :class="{ 'text-danger': errors.has('content_en') }"
            >
              {{ errors.first('content_en') }}
            </span>
          </div>
          <div class="col-sm-8 text-right mt-2">
            <ts-button
              class="btn-primary mt-2"
              @click.prevent="update"
              :waiting="waiting"
              >{{ $t('update') }}</ts-button
            >
            <ts-button
              class="mt-2 ml-2"
              @click="$router.push({ name: 'about' })"
              >{{ $t('cancel') }}</ts-button
            >
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import { VueEditor } from 'vue2-editor'

export default {
  components: { VueEditor },
  name: 'about-edit',
  data() {
    return {
      model: {
        company_id: '',
        content_kh: '',
        content_en: ''
      },
      waiting: false,
      errors: new Errors(),
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        [{ header: 1 }, { header: 2 }],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ color: [] }, { background: [] }],
        ['link', 'image'],
        [{ direction: 'rtl' }],
        ['clean']
      ]
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('about', ['edit_data'])
  },
  methods: {
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      var formData = new FormData()
      formData.append('image_content', file)
      this.$store
        .dispatch('about/aboutImageContent', formData)
        .then(response => {
          Editor.insertEmbed(cursorLocation, 'image', response)
          resetUploader()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    update() {
      this.waiting = true
      this.errors = new Errors()
      this.$store
        .dispatch('about/update', Object.assign({}, this.model))
        .then(response => {
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'about' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    setEditData() {
      this.model.company_id = this.edit_data.company_id
      this.model.content_kh = this.edit_data.content_kh
      this.model.content_en = this.edit_data.content_en
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('about/RESET_STATE')
      this.$store.commit('about/SET_EDIT_DATA', {})
    }
    next()
  }
}
</script>
<style>
.ql-editor {
  min-height: 23vh !important;
  height: 64vh !important;
  overflow-y: scroll !important;
}
</style>
